import {HttpErrorResponse} from '@angular/common/http';
import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ApiId, DistributionAccount} from '../../../../distribution-account/distribution-account.model';
import {SubscriptionHandler} from '../../../../utils/subscription-handler';
import {XandrService} from '../../../../xandr/xandr.service';
import {
  XandrBuyerBilling,
  XandrDataPriceCategoryBuyerCustomPrice,
  XandrSegment,
  XandrSegmentBilling
} from '../../../../xandr/xandr.types';
import {XandrPriceComponent} from './xandr-price/xandr-price.component';
import {XandrShareConfig} from '../../../../segment-multi-share/segment-share.service';

@Component({
  selector: 'app-account-xandr',
  templateUrl: './account-xandr.component.html',
  styleUrls: ['./account-xandr.component.scss']
})
export class AccountXandrComponent implements OnInit, OnDestroy {

  @Input() account!: DistributionAccount;
  @Output() priceChange = new EventEmitter<XandrShareConfig>();
  @ViewChild('price') price!: XandrPriceComponent;

  billing!: XandrSegmentBilling | null;
  segment!: XandrSegment;
  errorMessage!: string;
  loadingBillings = false;
  loadingSegment = false;
  updatingStatus = false;

  private subscriptionHandler = new SubscriptionHandler();

  constructor(public xandrService: XandrService) {
  }

  ngOnInit(): void {
    this.xandrService.isDryMode = !this.account?.segmentId;
    if (!this.xandrService.isDryMode) {
      this.loadData();
    }
  }

  ngOnDestroy() {
    if (this.account) {
      this.priceChange.emit({
        buyers: this.xandrService.buyers.getValue().get(this.account.id) || [],
        publishers: this.xandrService.publishers.getValue().get(this.account.id) || [],
        billing: this.billing as XandrSegmentBilling
      } as XandrShareConfig);
      this.subscriptionHandler.unsubscribe();
    }
  }

  updateStatus(active: boolean) {
    this.updatingStatus = true;
    this.segment.active = active;

    this.subscriptionHandler.subscription = this.xandrService
      .updateSegmentStatus(
        this.account.foreignIdForCurrentSegment,
        active,
        this.account.apiId
      ).subscribe({
        next: () => {
          this.updatingStatus = false;
        },
        error: (error: HttpErrorResponse) => {
          this.updatingStatus = false;
          console.error('🧨 Error', error);
          this.errorMessage = error.error ? JSON.stringify(error.error) : error.message;
        }
      });
  }

  showBuyers(): boolean {
    if (this.xandrService.isDryMode) {
      return !this.price?.publicSegment;
    }
    return this.billing !== null;
  }

  showLoading() {
    return this.loadingBillings || this.loadingSegment;
  }

  onPriceModified(billing: XandrSegmentBilling) {
    if (this.xandrService.isDryMode) {
      this.billing = billing;
    } else {
      this.loadSegmentBillingMapping();
    }
  }

  private loadData() {
    this.loadSegmentBillingMapping();

    this.loadingSegment = true;
    this.subscriptionHandler.subscription = this.xandrService.getSegment(this.account).subscribe({
      next: (segment) => {
        this.segment = segment;
        this.loadingSegment = false;
      },
      error: (error) => {
        this.handleError(error);
        this.loadingSegment = false;
      }
    });
  }

  private loadSegmentBillingMapping() {
    this.loadingBillings = true;
    this.subscriptionHandler.subscription = this.xandrService.getSegmentBillingMappings(this.account).subscribe({
      next: (data) => {
        this.billing = data;
        this.loadingBillings = false;
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
        this.billing = null;
        this.loadingBillings = false;
      }
    });
  }

  private handleError(error: HttpErrorResponse) {
    /* istanbul ignore else */
    if (error.status !== 404) {
      console.error('🧨 Error', error);
      this.errorMessage = error.message;
    }
  }
}
